enum JobType {
  Job,
  BulkJob,
}

export default JobType
